/* eslint-disable import/no-extraneous-dependencies, global-require,  */
import { configureStore } from '@reduxjs/toolkit';

import reducers from './reducers';
import middleware from './middleware';

export default function createStore(initialState = {}, storeConfig) {
	const store = configureStore({
		reducer: reducers,
		preloadedState: initialState,
		middleware: () => middleware(storeConfig),
		devTools: process.env.NODE_ENV !== 'production',
	});

	/* istanbul ignore if  */
	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('./reducers', () => {
			const nextRootReducer = require('./reducers').default;

			store.replaceReducer(nextRootReducer);
		});
	}

	return store;
}
